module.exports = __webpack_public_path__ + "static/Grid-100c23bceb2988a0c295bd4879ac9055.svg";